var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    fill: "#676b88",
    width: 23,
    height: 23,
    rx: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    fill: "#fff",
    d: "M5.21,15A6.87,6.87,0,0,1,14.93,5.3a6.74,6.74,0,0,1,1,8.3.27.27,0,0,0,0,.34l3.51,3.51a1.61,1.61,0,0,1,.28,2.25l0,.05-.11.1a1.6,1.6,0,0,1-2.25-.19l0-.05-3.5-3.5a.29.29,0,0,0-.35-.05A6.74,6.74,0,0,1,5.21,15Zm8.45-1.27a5.08,5.08,0,1,0-7.18,0h0A5.08,5.08,0,0,0,13.66,13.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    fill: "#fff",
    d: "M13.23,9.75a.7.7,0,0,0,.7-.71.62.62,0,0,0,0-.27A4.48,4.48,0,0,0,8,6.39a.71.71,0,0,0,.51,1.33l.05,0a3,3,0,0,1,4,1.62A.71.71,0,0,0,13.23,9.75Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails01);
export default __webpack_public_path__ + "static/media/Details-01.cd8a47c320a4ea5d9e1f30bbec28b0a0.svg";
export { ForwardRef as ReactComponent };